import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(window.MUI_LICENSE);
